import { StarIcon } from 'lucide-react';

import styles from './ReviewScore.module.scss';

interface Props {
    reviewScore: string;
}

export function ReviewScore({ reviewScore }: Props) {
    return (
        <div className={styles.container} data-review-score={reviewScore}>
            <StarIcon className={styles.star} />
            {reviewScore}
        </div>
    );
}
